import React, { useState, useEffect, useRef } from 'react';
import JSC from 'jscharting-react';

const parseSafeDate = (dateString, fallback = new Date()) => {
    const date = new Date(dateString);
    
    return isNaN(date) ? fallback : date;
  };

  const processData = (data) => {
    console.log("🚀 Dados Recebidos:", data);
    const cohorts = {};
    
    data.forEach(restaurant => {
      const createdAt = parseSafeDate(restaurant.createdAt, new Date(2000, 0, 1));
      const cohortMonth = createdAt.toISOString().slice(0, 7);
      
      if (!cohorts[cohortMonth]) {
        cohorts[cohortMonth] = {totalStart : 0 };
      }

      cohorts[cohortMonth].totalStart+=1;
      const cancelledDate = restaurant.cancelledAt && restaurant.cancelledAt !== 0
        ? new Date(restaurant.cancelledAt)
        : new Date();
      
        const createdYear = createdAt.getFullYear();
        const createdMonth = createdAt.getMonth();
        const cancelledYear = cancelledDate.getFullYear();
        const cancelledMonth = cancelledDate.getMonth();
      const monthsActive = (cancelledYear - createdYear) * 12 + (cancelledMonth - createdMonth);
  
      console.log(`📌 Restaurante ID: ${restaurant.id} | Criado: ${createdAt.toISOString()} | Cancelado: ${cancelledDate.toISOString()} | Meses Ativo: ${monthsActive}`);
  
      for (let i = 0; i <= monthsActive; i++) {
        const period = `Month${i}`;
  
        if (!cohorts[cohortMonth][period]) {
          cohorts[cohortMonth][period] = {
            count: 0,
            mrr: 0,
            rest_ids: [],
            retentionRate: 0
          };
        }
  
        cohorts[cohortMonth][period].count += 1;
        cohorts[cohortMonth][period].mrr += restaurant.mrr || 0;
        cohorts[cohortMonth][period].rest_ids.push(restaurant.id);
      }
    });
    
    Object.entries(cohorts).forEach(([cohortMonth, periods]) => {
      const totalStart = periods.totalStart; // Pegamos o total inicial desse cohort
  
      Object.entries(periods).forEach(([period, values]) => {
        if (period !== "totalStart") { 
          values.retentionRate = parseFloat(((values.count / totalStart) * 100).toFixed(2));
        }
      });
    });
    
    console.log("📊 Cohorts Processados:", JSON.stringify(cohorts, null, 2)); // 🔹 Log estruturado para melhor leitura
    return cohorts;
  };
  


const CohortChart = ({ data,cohortYear,setCohortYear,availableYears }) => {
    const [selectedMetric, setSelectedMetric] = useState('Retenção');
    const [chartOptions, setChartOptions] = useState(null);
    const palette = ['#800000', '#8B0000', '#A52A2A', '#E9967A', '#FFA07A', '#FFE4C4'].reverse();

  useEffect(() => {
    if (!data || data.length === 0) return;

      
    
    const cohorts = processData(data);
    
    const seriesData = [];



    Object.entries(cohorts).forEach(([cohort, periods]) => {
      const points = [];
    
      Object.entries(periods).forEach(([period, values]) => {
        if (period === "totalStart") return; // 🚨 Ignora a chave totalStart
    
        points.push({
          x: period,
          y: cohort,
          z: selectedMetric === 'MRR' 
  ? parseFloat(values.mrr.toFixed(2)) 
  : selectedMetric === 'Retenção' 
    ? parseFloat(values.retentionRate.toFixed(2)) 
    : values.count,

colorValue: selectedMetric === 'MRR' 
  ? parseFloat(values.mrr.toFixed(2)) 
  : selectedMetric === 'Retenção' 
    ? parseFloat(values.retentionRate.toFixed(2)) 
    : values.count,

    
    attributes: {
      cohort,
      period,
      mrr: parseFloat(values.mrr.toFixed(2)),
      count: values.count,
      retention: parseFloat(values.retentionRate.toFixed(2))
    }
    
        });
      });
    
      seriesData.push({ points });
    });
    

const validValues = seriesData
  .flatMap(s => s.points.map(p => p.z))
  .filter(z => typeof z === 'number' && !isNaN(z));

const maxValue = validValues.length > 0 ? Math.max(...validValues) : 0;
console.log("Valores válidos de z:", validValues); 
console.log("Valor máximo (maxValue):", maxValue); 

    console.log("Valores da Paleta: ",maxValue, seriesData);
    const cohortCount = Object.keys(cohorts).length;
    const dynamicHeight = Math.max(400, cohortCount * 45); 
    const config = {
      type: 'heatmap',
      height: dynamicHeight,
      chartArea: { margin: [60, 20, 80, 120] },
      palette: {
        colors: palette,
        colorsValueRange: [0, maxValue],
        pointValue: '{%zValue}',
        pointValueInterpolation: 'linear',
        stops: palette.length
      },
      xAxis: {
        label_text: 'Período desde a criação',
        scale: { interval: 1 }
      },
      yAxis: {
        label_text: 'Cohort (Mês de Criação)',
        scale: { invert: true }
      },
      defaultPoint: {
        tooltip: selectedMetric === 'MRR'
          ? '<b>%yValue</b><br>%xValue<br>MRR: {%zValue:n0}'
          : selectedMetric === 'Retenção'? '<b>%yValue</b><br>%xValue<br>Retenção: {%zValue:n0}%'
          : '<b>%yValue</b><br>%xValue<br>Restaurantes Ativos: {%zValue:n0}',
        label_text: '{%zValue:n0}'
      },
      series: seriesData.map(s => ({
        ...s,
        defaultPoint_colorValue: '{%zValue}'
      }))
    };
    
    
  
      setChartOptions(config);
    }, [data, selectedMetric]);
  
    return (
      <div >
        <div style={{ marginBottom: '20px' ,padding:'20px'}}>
          <select 
            value={selectedMetric} 
            onChange={(e) => setSelectedMetric(e.target.value)}
            className='custom-select'
          >
            <option value="MRR">MRR</option>
            <option value="Restaurantes">Restaurantes</option>
            <option value="Retenção"> Retenção</option>
          </select>
          <select
        value={cohortYear}
        onChange={(e) => setCohortYear(e.target.value)}
        className='custom-select'

      >
        {availableYears.map((year) => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
        </div>
        
        {chartOptions && (
          <JSC 
            style={{ width: '100%', height: '500px', padding:'20px'}}
            options={chartOptions}
          />
        )}
      </div>
    );
  };

export default CohortChart;